module.exports = __webpack_public_path__ + "img/white_paper1.f48d1d1a.png";